import { graphql } from '../../graphqlTypes/graphql';

export const CreateOnboardingAnalystProject = graphql(`
  mutation CreateOnboardingAnalystProject($industry: IndustryType!) {
    createOnboardingAnalystProject(industry: $industry) {
      _id
      name
    }
  }
`);

export const UpdateUserOnboardingDetails = graphql(`
  mutation UpdateUserOnboardingDetails($profession: String!, $industry: IndustryType!) {
    updateUserOnboardingDetails(profession: $profession, industry: $industry)
  }
`);

export const GetUserOnboardingDetails = graphql(`
  query GetUserOnboardingDetails($uid: String!) {
    User(uid: $uid) {
      profession
      industry
    }
  }
`);
